const getDefaultState = () => {
  return {
    agentIDforAI: null,
    inferredKeys: [] // AI 추론 완료 리스트 (콜 (callKey), 톡 (chatRoomId))
  };
};
const state = getDefaultState();

const getters = {
  getAgentIDforAI: (state) => {
    return state.agentIDforAI;
  },
  getInferredKeys: (state) => {
    return state.inferredKeys; // AI 추론 완료 챗룸ID List
  }
};

const mutations = {
  setAgentIDforAI(state, agentId) {
    state.agentIDforAI = agentId;
  },
  setInferredKeys(state, payload) {
    if (payload.agentId) {
      state.agentIDforAI = payload.agentId;
    }
    let temp = [...state.inferredKeys, ...payload.keys];
    state.inferredKeys = temp.filter((el, i) => temp.indexOf(el) === i);
  },
  deleteInferredKey(state, key) {
    state.inferredKeys = state.inferredKeys.filter((el) => el !== key);
  },
  CLEAR_AI(state) {
    Object.assign(state, getDefaultState());
  }
};
export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/inferenceAI/index.js